import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { EventFormComponent } from './event-form/event-form.component';
import { EventListComponent } from './event-list/event-list.component';
import { EventOverviewComponent } from './event-overview/event-overview.component';

const routes: Routes = [
  {
    path: 'events',
    children: [
      {
        path: '',
        component: EventListComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
      },
      {
        path: 'create',
        component: EventFormComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
      },
      {
        path: ':eventId',
        component: EventOverviewComponent,
        canActivate: [AuthGuard],
        pathMatch: 'full',
      },
    ],
  },
  { path: '', redirectTo: '/events', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class EventRoutingModule {}
